import { Panel, PanelHeader, PanelBody } from '../ui/Panel';

export default function Placeholder({ title, comingWith }: { title: string; comingWith?: string }) {
  return (
    <Panel>
      <PanelHeader title={title} />
      <PanelBody className="text-table text-ink-2">Coming with {comingWith ?? 'a later update'}.</PanelBody>
    </Panel>
  );
}
